import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
/**
 * The repeatable "Association(s)" name+link rows - shared between
 * SignUpModal (addRegistrationFields.js) and the settings page
 * (addProfileSettings.js), since it's the exact same field in both places.
 * `associations` is mutated in place (push/splice/property assignment) -
 * the array reference belongs to the caller, this just renders it and
 * triggers a redraw after any change, same as a controlled list anywhere
 * else in this codebase.
 */
export default function associationsField(associations, _temp) {
  let {
    disabled = false,
    labelSuffix
  } = _temp === void 0 ? {} : _temp;
  const t = key => app.translator.trans(`champis-users.forum.profile_fields.${key}`);
  const label = key => extractText(t(key));
  return m("div", {
    className: "Form-group ChampisAssociations"
  }, m("label", {
    className: "label"
  }, t('associations_label'), labelSuffix?.()), associations.map((association, index) => m("div", {
    className: "ChampisAssociations-row",
    key: index
  }, m("input", {
    className: "FormControl",
    type: "text",
    placeholder: label('association_name_placeholder'),
    "aria-label": label('association_name_placeholder'),
    value: association.name,
    oninput: e => association.name = e.target.value,
    disabled: disabled
  }), m("input", {
    className: "FormControl",
    type: "url",
    placeholder: label('association_url_placeholder'),
    "aria-label": label('association_url_placeholder'),
    value: association.url,
    oninput: e => association.url = e.target.value,
    disabled: disabled
  }), m(Button, {
    icon: "fas fa-times",
    className: "Button Button--icon ChampisAssociations-remove",
    "aria-label": label('remove_association_button'),
    disabled: disabled,
    onclick: () => {
      associations.splice(index, 1);
      m.redraw();
    }
  }))), m(Button, {
    icon: "fas fa-plus",
    className: "Button ChampisAssociations-add",
    disabled: disabled,
    onclick: () => {
      associations.push({
        name: '',
        url: ''
      });
      m.redraw();
    }
  }, t('add_association_button')));
}
flarum.reg.add('champis-users', 'forum/utils/associationsField', associationsField);